import { extractFreelancerGtmData } from '@/helpers/tracking'

export default function ({ app, store }) {
  const auth = app.$auth

  if (process.client && auth.loggedIn) {
    app.$pushEvent('freelancerData', extractFreelancerGtmData({ auth, store }), true)
  }
}
